module.exports = __webpack_public_path__ + "static/media/cvo-tri-glide-sunset-orange-fade.c83a1352.png";